import { logger } from 'utils/logger'

import * as actionTypes from '../actionTypes/Feedback'
import { updateObject } from '../utility'

export const initialState = {
    feedbackQuestion: {},
    isLoading: false,
    isFeedbackSubmitted: false,
}

const setFeedbackStateRequest = state => {
    return updateObject(state, { isLoading: true })
}

const setFeedbackStateSuccess = (state, action) => {
    return updateObject(state, {
        feedbackQuestion: action.feedbackQuestion,
        isLoading: false,
    })
}

const setFeedbackStateFailure = (state, action) => {
    logger.error(action.error)
    return updateObject(state, { isLoading: false })
}

const submitFeedbackSuccess = (state, action) => {
    return updateObject(state, {
        isFeedbackSubmitted: action.status,
    })
}

const Feedback = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_FEEDBACK_STATE_REQUEST:
            return setFeedbackStateRequest(state, action)
        case actionTypes.SET_FEEDBACK_STATE_SUCCESS:
            return setFeedbackStateSuccess(state, action)
        case actionTypes.SET_FEEDBACK_STATE_FAILURE:
            return setFeedbackStateFailure(state, action)
        case actionTypes.SUBMIT_FEEDBACK_SUCCESS:
            return submitFeedbackSuccess(state, action)
        default:
            return state
    }
}

export default Feedback
